import controller from './paycell-info-dialog.controller';

export default {
  controller,
  template: require('./paycell-info-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/paycell-info-dialog/paycell-info-dialog.component.ts